import React from "react";
const Loader = () => {
    return (
        <div className="loader-container h-100 w-100 d-flex justify-content-center align-items-center">
            <div className="spinner-grow text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
            </div>
        </div>
    )
}

export default Loader;